import { NgModule } from '@angular/core';
import { ConcertMainComponent } from './concert-main.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { ReservationItemModule } from '../../ticket/reservation-item/reservation-item.module';
import { ConcertItemComponent } from '../concert-item/concert-item.component';
import { YandexMapModule } from 'src/app/components/(map)/yandex-map/yandex-map.module';
import { ImportModule } from 'src/app/import.module';
import { ImageGalleryModule } from 'src/app/components/(image)/image-gallery/image-gallery.module';
import { SafeModule } from 'src/app/pipes/safe.module';
import { TranslatePipeModule } from 'src/app/pipes/translate.module';
import { ConcertGroupedComponent } from '../concert-grouped/concert-grouped.component';

@NgModule({
  imports: [
    ImportModule,
    ReactiveFormsModule,
    ReservationItemModule,
    SafeModule,
    ImageGalleryModule,
    YandexMapModule,
    TranslatePipeModule,
  ],
  declarations: [
    ConcertMainComponent,
    ConcertItemComponent,
    ConcertGroupedComponent,
    // SafePipe,
  ],
  exports: [
    ConcertMainComponent,
    ConcertItemComponent,
    ConcertGroupedComponent,
  ],
})
export class ConcertMainModule {}
